import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ title, subtitle, linkTo, linkLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="font-display font-black text-xl md:text-2xl text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {linkLabel || "查看全部"}
          <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center"></i>
        </Link>
      )}
    </div>
  );
}